import { Component } from '@theme/component';

/** @extends {Component<{search:HTMLInputElement,status:HTMLElement,empty:HTMLElement,translations:HTMLScriptElement}>} */
class JubiloGallery extends Component {
  connectedCallback() { super.connectedCallback(); this.initialize(); }
  updatedCallback() { super.updatedCallback(); this.initialize(); }
  disconnectedCallback() { super.disconnectedCallback(); this.events?.abort(); }

  initialize() {
    // Never promote unpublished catalog snapshots into a published storefront.
    if (window.Shopify?.designMode || window.Shopify?.theme?.role === 'unpublished') {
      for (const template of this.querySelectorAll('template[data-draft-card]')) {
        template.replaceWith(template.content.cloneNode(true));
      }
    }
    this.cards = [...this.querySelectorAll('[data-card]')];
    this.groups = [...this.querySelectorAll('[data-group]')];
    this.labels = JSON.parse(this.refs.translations.textContent);
    const initial = this.dataset.defaultFamily;
    this.family = this.family || (['granja','salvajes','casa','personajes','correlones'].includes(initial) ? initial : 'all');
    for (const control of this.querySelectorAll('[data-enhanced]')) control.hidden = false;
    for (const counter of this.querySelectorAll('[data-count]')) {
      const family = counter.dataset.count;
      counter.textContent = this.cards.filter(card => this.belongs(card, family)).length;
    }
    this.events?.abort();
    this.events = new AbortController();
    document.addEventListener('shopify:block:select', event => {
      const card = event.target.closest('[data-card]');
      if (!card || !this.contains(card)) return;
      this.family = card.dataset.family;
      this.refs.search.value = '';
      this.render();
    }, { signal: this.events.signal });
    this.render();
  }

  belongs(card, family) {
    return family === 'all' || (family === 'correlones' ? card.dataset.correlon === 'true' : card.dataset.family === family);
  }
  normalize(text) { return text.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }

  /** @param {MouseEvent} event */
  chooseFamily(event) {
    const control = event.target.closest('[data-family]');
    if (!control || !this.contains(control)) return;
    event.preventDefault();
    this.family = control.dataset.family;
    this.refs.search.value = '';
    this.render();
    if (control.classList.contains('jg__family')) {
      this.querySelector('.jg__catalog').scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  }
  searchProducts() { this.render(); }
  clearFilters() { this.family = 'all'; this.refs.search.value = ''; this.render(); this.refs.search.focus({preventScroll:true}); }
  render() {
    const query = this.normalize(this.refs.search.value.trim());
    let count = 0;
    for (const card of this.cards) {
      const visible = this.belongs(card, this.family) && this.normalize(card.dataset.name).includes(query);
      card.hidden = !visible;
      if (visible) count++;
    }
    for (const group of this.groups) {
      const visible = [...group.querySelectorAll('[data-card]')].filter(card => !card.hidden).length;
      group.hidden = visible === 0;
      group.querySelector('[data-group-count]').textContent = visible;
    }
    for (const button of this.querySelectorAll('.jg__filter')) button.setAttribute('aria-pressed', String(button.dataset.family === this.family));
    this.refs.status.textContent = count === 1 ? this.labels.countOne : this.labels.count.replace('__COUNT__', String(count));
    this.refs.empty.hidden = count !== 0;
  }
}
if (!customElements.get('jubilo-gallery-component')) customElements.define('jubilo-gallery-component', JubiloGallery);
